import { useContext } from 'react';
import { useStaticQuery } from 'gatsby';
import { LanguageContext } from '../providers';
import { findT } from '../components/_helpers';
export const useHeaderData = () => {
  const {
    language
  } = useContext(LanguageContext);
  const {
    directusProject,
    directusMenus,
    directusMenusNew
  } = useStaticQuery("109755977");
  const translations = findT(directusProject.translations, language);
  const menu = directusMenus ? findT(directusMenus.translations, language).config : null;
  const menuNew = directusMenusNew ? directusMenusNew.config : null;
  return {
    language,
    logo: directusProject.logo,
    seo_title: translations.seo_title,
    config: directusProject.config[0],
    menu,
    menuNew
  };
};